/**
 * The board's column titles, on the row grid (moved out of BoardCard,
 * 23/10/2026): Container · Schedule · Today's list · List group · Progress ·
 * State.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { HintDot } from '@/components/ui';

import { BOARD_GRID } from '../ContainerRow';

export const BoardColumnsHead: FC = () => (
  <div className={`${BOARD_GRID} border-b border-border/60 py-2 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground`}>
    <span />
    <span />
    <span>Container</span>
    <span>Schedule</span>
    <span className="flex items-center gap-1">
      Today&apos;s list
      <HintDot label="Each drop's list today, in send order — a list shows each time it is used; hover for today's lists. Progress and State are the day as it stands — the same facts as the Live tab." />
    </span>
    <span>List group</span>
    <span>Progress</span>
    <span>State</span>
    <span />
  </div>
);
